'use client';

import { createClient } from '@/prismicio';
import { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
import { Content } from '@prismicio/client';
import { SliceZone } from '@prismicio/react';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

import { Box, EmptyState, Wrapper } from '@preventx/oxygen';

// Types
import { PageParams } from '@/types/routing';

// Slices
import { components as errorComponents } from '@/slices/error';

export const ServerError = () => {
  const { lang } = useParams<PageParams>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<Content.NotFoundDocumentData | undefined>(
    undefined,
  );

  const initialise = async () => {
    const client = createClient();

    try {
      const { data } = await client.getSingle('error', { lang: lang });

      setData(data);
    } catch {
      setData(undefined);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    initialise();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <Wrapper size="lg">
      <Box component="div" addFlow>
        {!data && (
          <EmptyState title="Error" icon={faTriangleExclamation}>
            An error occurred whilst processing the request.
          </EmptyState>
        )}

        {data && (
          <SliceZone slices={data.slices} components={errorComponents} />
        )}
      </Box>
    </Wrapper>
  );
};
